import React from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

// Clicking a nav item for the page you are already on normally does nothing in a
// single-page app. These wrappers make that click RELOAD the current page instead,
// so tapping e.g. "Tableau de bord" while on the dashboard refreshes it. Behaves
// exactly like Link / NavLink otherwise (all props are forwarded).

const pathOf = (to) =>
  typeof to === 'string' ? to.split('?')[0].split('#')[0] : (to && to.pathname) || '';

// Plain left-click with no modifier (so ctrl/cmd/middle-click-to-new-tab still work).
const isPlainClick = (e) =>
  e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;

function useSamePathReload(to, onClick) {
  const location = useLocation();
  return (e) => {
    if (onClick) onClick(e);
    if (e.defaultPrevented) return;
    if (pathOf(to) === location.pathname && isPlainClick(e)) {
      e.preventDefault();
      window.location.reload();
    }
  };
}

export default function RefreshLink({ to, onClick, ...rest }) {
  const handleClick = useSamePathReload(to, onClick);
  return <Link to={to} onClick={handleClick} {...rest} />;
}

export function RefreshNavLink({ to, onClick, ...rest }) {
  const handleClick = useSamePathReload(to, onClick);
  return <NavLink to={to} onClick={handleClick} {...rest} />;
}
